module.exports = __webpack_public_path__ + "imgs/staff1.7883123e.webp";